const babyAiTranslation = {
  mode: 'ko',
  babyAiMenu: '베이비매직 리스트',

  babyAiListTitle: '베이비매직 리스트',

  seq: '번호',
  hospital: '병원',
  hospitalRoom: '진료실',
  barcode: '바코드',
  userSeq: '유저 번호',
  babySeq: '아이 번호',
  createTime: '생성 시간',
  aiImage: 'AI 보정 이미지',
  captureImage: '캡처 이미지',
  hiddenBabyImage: '히든베이비 이미지',
  babyMagicImage: '베이비매직 이미지',
  visibleFlag: '공개 여부',
  manage: '관리',
  webhookSentAt: '웹훅 전송 시간',
  send: '전송',

  public: '공개',
  private: '비공개',
  manual: '재전송',
  noBabyMagic: '베이비매직 이미지 없음',

  searchBarcode: '바코드 검색',

  visibleFlagInactiveMessage: '비공개로 변경하시겠습니까?',
  visibleFlagActiveMessage: '공개로 변경하시겠습니까?',

  // 베이비매직 생성 관련
  createBabyMagic: '베이비매직 생성',
  babyMagicCreateSuccess: '베이비매직 생성이 완료되었습니다.',
  title: '제목',
  enterTitle: '제목을 입력하세요',
  ethnicity: '민족',
  skinTone: '피부톤',
  selectCapture: '캡처 이미지 선택',
  selectCaptureRequired: '캡처 이미지를 선택해주세요.',
  selectBabyRequired: '아이를 선택해주세요.',

  // UI 텍스트
  videoInfo: '영상 정보',
  recordingNumber: '영상번호',
  userInfo: '유저 정보',
  loadingUserInfo: '유저 정보 조회 중...',
  userNumber: '유저번호',
  fullName: '성명',
  noName: '이름 없음',
  phoneNumber: '전화번호',
  babyInfo: '아이 정보',
  babyNumber: '아이번호',
  babyNickname: '태명',
  twins: '쌍둥이',
  noBabyInfo: '등록된 아기 정보가 없습니다',
  noRegisteredBaby: '바코드에 등록된 아이가 없습니다.',
  captureNumber: '캡처번호',
  viewLarge: '크게보기',
  selectionRequired: '아이 번호와 초음파 캡처를 선택해야 생성 가능',
};

export default babyAiTranslation;
